import { connect } from 'react-redux'
import Breadcrumbs from 'components/Breadcrumbs'
import { selectTitle, selectContentType, selectDevice } from './selectors'

const BreadcrumbsContainer = (props) => <Breadcrumbs {...props} />

const mapStateToProps = (state) => ({
  title: selectTitle(state),
  contentType: selectContentType(state),
  device: selectDevice(state)
})

export default connect(mapStateToProps)(BreadcrumbsContainer)
